import { Link } from '@tanstack/react-router';
import { EmptyState } from '@/component';

/** Shown inside the app chrome for any address no route claims. */
export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center gap-4 pt-[52px]">
      <EmptyState title="Page not found" body="The page you're looking for doesn't exist." />
      <Link to="/" className="text-sm font-medium text-acc hover:underline">
        Back home
      </Link>
    </div>
  );
}
